/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { createSelector } from '@reduxjs/toolkit';
import { SLICE } from 'modules/dashboard/constants';
import { initialState } from 'modules/dashboard/components/tab-container/trend-tabular-tabs/slice';
//
const selectDomain = (state) => state[SLICE.TREND_TABULAR] || initialState;
/*
 *Getting trend data state for the component
 */
export const selectTrendData = createSelector([selectDomain], (state) => state?.trendData);
/*
 *Getting the number of completed trend data requests, it changes when a request succeeds or fails
 */
export const selectTrendDataResponseId = createSelector(
  [selectDomain],
  (state) => state?.trendDataResponseId ?? 0
);
/**
 *  Getting generated trend tabular tab url
 */
export const selectTrendTabularUrl = createSelector(
  [selectDomain],
  (state) => state.trendTabularUrl
);
